import { render, staticRenderFns } from "./RejectionReasonsForm.vue?vue&type=template&id=7d58f6df&"
import script from "./RejectionReasonsForm.vue?vue&type=script&lang=js&"
export * from "./RejectionReasonsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports